import React from "react";

export default function About() {
  return (
    <div className="About-page">
      <p>
        Hi! I am Iftekharul Abedeen, a graduate of Software Engineering from the
        Department of Computer Science and Engineering at the Islamic University
        of Technology (IUT). I am currently employed as a lecturer in the
        Department of Computer Science and Engineering of United Internal
        University (UIU).
      </p>

      <p>
        I enjoy travelling, playing video games, listening to music and reading
        fictions.
      </p>
    </div>
  );
}
